import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import LinkWrapper from '@common/components/linkWrapper';
import Profile from '@common/components/profile';
import Api from '../../../../common/services/api';
import Modal from '../../../../common/components/modal';
import SearchableList from '../../../../common/components/list/search';
import ImageItem from '../../../../common/components/image-item';

class FunctionDetailModal extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    function: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    organisation: PropTypes.object,
    network: PropTypes.object,
  };

  constructor() {
    super();

    this.handleRequest = this.handleRequest.bind(this);
  }

  handleRequest(offset, filter, limit = 15) {
    const { organisation, network, function: item } = this.props;

    const query = Api.utils.toQuery({
      offset,
      limit,
      q: filter.query,
    });

    const baseUrl = organisation
      ? `/v2/organisations/${organisation.id}`
      : `/v2/networks/${network.id}`;

    return Api.get(`${baseUrl}/functions/${item.id}/users?${query}`);
  }

  render() {
    const { children, function: organisationFunction, t, network } = this.props;
    const basePath = network ? `/networks/${network.id}` : '/admin';

    return (
      <Modal
        onEnter={this.handleShow}
        title={<span><Trans i18nKey="organisation:function_title" values={{ organisationFunctionName: organisationFunction.name }} /></span>}
        content={(
          <SearchableList
            data={{
              onFetch: this.handleRequest,
            }}
            renderRow={(props) => (
              <LinkWrapper url={`${basePath}/users/${props.item.id}/about`} className="tw-text-inherit hover:tw-text-inherit tw-mb-2 last:tw-mb-0 tw-block hover:tw-underline">
                <Profile {...props} size={30} enablePopover />
              </LinkWrapper>
            )}
            rowProps={(user) => ({
              mask: true,
              image: user.profile_img,
              name: user.full_name,
              user: { id: user.id, full_name: user.full_name, profile_img: user.profile_img },
            })}
            containerClassName="ItemsList"
            placeholder={t('organisation:function_placeholder')}
          />
        )}
      >
        {children}
      </Modal>
    );
  }
}

export default withTranslation()(FunctionDetailModal);
